import React from 'react'
import * as url from '_routes/url-names'
import AuthRoute from '_routes/authenticated-route'

const NewRecruitment = React.lazy(() => import('_containers/recruitment/recruitment-new'))
const Overview = React.lazy(() => import('_containers/recruitment/overview'))
const RecruitmentEdit = React.lazy(() => import('_containers/recruitment/recruitment-edit'))
const RecruitmentApplication = React.lazy(() => import('_containers/recruitment/recruitment-application'))
const ApplicationCurrent = React.lazy(() => import('_containers/application/application-current'))
const ApplicationHistory = React.lazy(() => import('_containers/application/application-history'))
const ApplicationLogbook = React.lazy(() => import('_containers/application/application-logbook'))
const WorkDocumentsApplication = React.lazy(() => import('_components/recruit/work-documents-application'))
const RecruitBaseEdit = React.lazy(() => import('_components/recruit/recruit-base-edit'))
const Advertise = React.lazy(() => import('_components/recruit/advertise'))
const Publishing = React.lazy(() => import('_root/components/recruit/publishing'))
const RecruitmentInfo = React.lazy(() => import('_components/recruit/recruitment-info'))
const RecruitingDeals = React.lazy(() => import('_modules/recruitments/components/advertisement/recruiting-deals'))
const Planning = React.lazy(() => import('_components/recruit/planning'))
const LogBook = React.lazy(() => import('_components/recruit/logbook'))
const WorkDocuments = React.lazy(() => import('_components/recruit/work-documents'))
const RecruitmentApplications = React.lazy(() => import('_containers/recruitment/recruitment-applications'))
const ApplicationList = React.lazy(() => import('_components/applications/application-list'))
const AfterLogin = React.lazy(() => import('_root/containers/after-login'))
const ApplicationProtocol = React.lazy(() => import('_root/containers/application/application-protocol'))

export default [
  {
    path: url.COMPANY + url.REKRYTERING + url.REK_NY,
    element: <AuthRoute component={NewRecruitment} />
  },
  {
    path: url.COMPANY + url.REKRYTERING + url.REK_STATE,
    element: <AuthRoute component={Overview} />
  },
  {
    path: url.COMPANY + url.REK_PROTOCOL + url.REK_PROTOCOL_ID,
    element: <AuthRoute component={ApplicationProtocol} />
  },
  {
    path: url.COMPANY + url.REK_APPLICATION + url.REK_APPLICATION_ID,
    element: <AuthRoute component={RecruitmentApplication} />,
    children: [
      { index: true, element: <AuthRoute component={ApplicationCurrent} /> },
      { path: url.COMPANY + url.REK_APPLICATION + url.REK_APPLICATION_ID + url.REK_APP_HISTORY, element: <AuthRoute component={ApplicationHistory} /> },
      { path: url.COMPANY + url.REK_APPLICATION + url.REK_APPLICATION_ID + url.REK_LOGGBOK, element: <AuthRoute component={ApplicationLogbook} /> },
      { path: url.COMPANY + url.REK_APPLICATION + url.REK_APPLICATION_ID + url.REK_APP_DOK, element: <AuthRoute component={WorkDocumentsApplication} /> }
    ]
  },
  {
    path: url.COMPANY + url.REKRYTERING + url.REK_NY + url.REK_ID,
    element: <AuthRoute component={RecruitmentEdit} />
  },
  {
    path: url.COMPANY + url.REKRYTERING + url.REK_STATE + url.REK_ID,
    element: <AuthRoute component={RecruitmentEdit} />,
    children: [
      { index: true, element: <AuthRoute component={RecruitBaseEdit} /> },
      { path: url.COMPANY + url.REKRYTERING + url.REK_STATE + url.REK_ID + url.REK_ANNONS, element: <AuthRoute component={Advertise} /> },
      { path: url.COMPANY + url.REKRYTERING + url.REK_STATE + url.REK_ID + url.REK_KANALER, element: <AuthRoute component={Publishing} /> },
      { path: url.COMPANY + url.REKRYTERING + url.REK_STATE + url.REK_ID + url.REK_APP_DOK, element: <AuthRoute component={WorkDocuments} /> },
      { path: url.COMPANY + url.REKRYTERING + url.REK_STATE + url.REK_ID + url.REK_INFO, element: <AuthRoute component={RecruitmentInfo} /> },
      { path: url.COMPANY + url.REKRYTERING + url.REK_STATE + url.REK_ID + url.REK_BOKA, element: <AuthRoute component={RecruitingDeals} /> },
      { path: url.COMPANY + url.REKRYTERING + url.REK_STATE + url.REK_ID + url.REK_PLANERA, element: <AuthRoute component={Planning} /> },
      { path: url.COMPANY + url.REKRYTERING + url.REK_STATE + url.REK_ID + url.REK_LOGGBOK, element: <AuthRoute component={LogBook} /> }
    ]
  },
  {
    path: url.COMPANY + url.REKRYTERING + url.REK_STATE + url.REK_ID + url.REK_APPLICATIONS,
    element: <AuthRoute component={RecruitmentApplications} />,
    children: [
      { index: true, element: <AuthRoute component={ApplicationList} /> }
    ]
  },
  {
    path: url.COMPANY + url.REKRYTERING,
    element: <AuthRoute component={AfterLogin} />
  }
]
